import React from "react";
import styles from "./adCard.scss"
import { CoverImage } from "../CoverImage";
import { AdStatusLabel } from "../MyAdsCard/AdStatusLabel";
import { AboveTitle } from "./AboveTitle";
import { truncate } from "../../../../utils/truncateWord";
import { ExpirationInfo } from "./ExpirationInfo";
import { AdStatus, LinkTargetEnum, PageRoute } from "../../../../models";
import { AdPrice } from "../AdSummary/AdPrice";
import { useAdPrice } from "./hooks/useAdPrice";
import { Icon, Tooltip } from "antd";
import { getIconUrl } from "../../../../services/asset";
import { AdCardActions } from "./AdCardActions/AdCardActions";
import { AdLink } from "../../../../components/AdCard/AdLink";
import history from "../../../../history";
import ReactGA from "react-ga4";

const SHOULD_SHOW_SAVES_AND_VIEWS = false

export const AdCard = (props) => {
  const {
    ad,
    onPriceChange,
    shouldShowDiscountPromoTooltip,
    isMobile,
  } = props;

  const {
    onEditPriceStart,
    onEditPriceCancel,
    isEditingPrice,
    canEditPrice,
    onEditPriceSave,
    editPriceValue,
    setEditPriceValue,
    editPriceToValue,
    setEditPriceToValue,
    isPriceChangeTriggeredFromCTA,
    wasDiscountPromoEventTriggered,
    tooltipVisible,
    setTooltipVisible,
  } = useAdPrice(ad, shouldShowDiscountPromoTooltip, onPriceChange)


  const handleStatisticsClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    ReactGA.event({
      category: "Moji oglasi",
      action: "click",
      label: "Statistika oglasa"
    });
    // Attach the viewed ad id to the current history entry so browser back
    // from statistics can restore the exact card.
    history.replace({
      pathname: history.location.pathname,
      search: history.location.search,
      state: { lastViewedAdId: ad.id }
    });
    history.push(`${PageRoute.statistics}/${ad.id}`);
  }

  // Guard against inner buttons that only call preventDefault (share, sold,
  // edit, …) — their clicks bubble to AdLink, so without this check we'd
  // track a fake "Otvoren oglas" for every action button.
  const handleAdLinkClick = (e: any) => {
    if (e && e.defaultPrevented) return;
    ReactGA.event({
      category: "Moji oglasi",
      action: "click",
      label: "Otvoren oglas"
    });
    if (props.onClick) props.onClick(e);
  }

  const cardContent = (
    <div className={styles.adCard}>
      <div className={styles.coverImageWrapper}>

        <CoverImage ad={ad} />
        <AdStatusLabel status={ad.status} />
      </div>
      <div className={styles.contentWrapper}>
        <div>
          <AboveTitle ad={ad} />
          <div className={styles.title}>
            {truncate(ad.title, 60) || ""}
          </div>
          {(ad.status === AdStatus.active || ad.status === AdStatus.paused) && <ExpirationInfo ad={ad} />}
        </div>

        <div className={styles.contentBottomWrapper}>
          <div className={styles.adPriceWrapper}>
            {ad.previousPrice && (
              <div className={styles.previousPrice}>{ad.previousPrice}</div>
            )}
            <AdPrice
              price={ad.price}
              priceTo={ad.priceTo}
              rentPriceType={ad.rentPriceType}
              priceType={ad.priceType}
              editable={!!canEditPrice}
              isEditing={isEditingPrice}
              editValue={editPriceValue}
              editToValue={editPriceToValue}
              onEditStart={onEditPriceStart}
              onEditChange={setEditPriceValue}
              onEditToChange={setEditPriceToValue}
              onEditSave={onEditPriceSave}
              onEditCancel={onEditPriceCancel}
              adStatus={ad.status}
              adId={ad.id}
              shouldShowDiscountPromoTooltip={shouldShowDiscountPromoTooltip}
              isPriceChangeTriggeredFromCTA={isPriceChangeTriggeredFromCTA}
              wasDiscountPromoEventTriggered={wasDiscountPromoEventTriggered}
              tooltipVisible={tooltipVisible}
              setTooltipVisible={setTooltipVisible}
            />
          </div>
          <div className={styles.adViewInfo} onClick={handleStatisticsClick}>
            {SHOULD_SHOW_SAVES_AND_VIEWS ? (
              <div style={{ display: "flex", gap: 20 }}>

                <Tooltip
                  title="Broj spremanja oglasa"
                >
                  <Icon type="heart"
                    className={styles.icon} /> <span className={styles.count}>{ad.favoriteCount}</span>
                </Tooltip>
                <Tooltip
                  title="Broj pregleda oglasa"
                >
                  <img
                    alt={"Statistika"}
                    src={getIconUrl("eye-visible.svg")}
                    className={styles.icon}
                  /> <span className={styles.count}>{ad.viewCount}</span>
                </Tooltip>
              </div>
            ) : <div />}
            <span className={styles.statisticsLink}>

              <img
                alt={"Statistika"}
                src={getIconUrl("statistics.svg")}
              />  {isMobile ? "Pogledaj statistiku" : "Statistika"}
            </span>

          </div>
        </div>
      </div>
      <AdCardActions {...props} />

    </div>
  )

  return isEditingPrice ? cardContent : (
    <AdLink ad={ad} onClick={handleAdLinkClick} target={LinkTargetEnum.blank}>
      {cardContent}
    </AdLink>
  )
}



// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/MyAds/AdCard/AdCard.tsx